import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { Helmet } from "react-helmet"

export const Badge = ({ title }) => {
 return <span className="text-xs inline-block text-gray-500 bg-gray-100 px-2 py-1 text-xs font-bold mr-1 mb-1">{ title }</span>
}

export const TakeAways = ({ content }) => {
  return (
    <section className="bg-yellow-100">
      <div className="max-w-screen-xl	mx-auto text-center">
        <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
          <div className="lg:w-10/12 md:w-10/12 sm:w-full flex flex-col justify-center items-center">
            <div className="content px-20">
              <p className="text-left font-bold text-2xl">
                Main Takeaways
              </p>
              <p className="text-left text-gray-600">
                { content } 
              </p>
            </div>
          </div>
          <div className="lg:w-2/12 md:w-2/12 sm:hidden md:block flex flex-col justify-center items-center">
            <img src={require('./images/takeaway-art.svg')} alt="Take away Art"/>
          </div>
        </div>
      </div>
    </section>
  )
}

export const LazyLoad = (img) => {
 return <LazyLoadImage alt={img.alt} effect="blur" src={img.src} wrapperClassName={img.className}/>
}

export const SeoHelmet = (props) => {
  return (
    <Helmet>
      <title>Loisy Salvacion | {props.title}</title>
      <meta name="description" content={props.description} />
    </Helmet>
  )
}
